import Results from "./Results";
import React, {useState}from "react";
import "./Dictionary.css"
import axios from "axios";
import Photos from "./Photos"

export default function Dictionary(){
    let [keyword, Setkeyword] = useState("");
    let [results, setResults] = useState(null);
    let [photos, setPhotos] = useState(null);
    
    function handleResponse(response){
        setResults(response.data[0])
    }

    function handlePexelReponse(response){
        setPhotos(response.data.photos)

    }

    function search(event){ 
        event.preventDefault();
        let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en/${keyword}`;
        axios.get(apiUrl).then(handleResponse);

        let pexelApiKey = "563492ad6f917000010000012b0049e01fad4d24af38238a78abb8d4";
        let pexelApiUrl = `https://api.pexels.com/v1/search?query=${keyword}}&per_page=5`;
        let header = {Authorization : `Bearer ${pexelApiKey}`} ;
        axios.get(pexelApiUrl, { headers: header }).then(handlePexelReponse);
    }

    function handleKeywordChange(event){
       Setkeyword(event.target.value);
    }

    return(
        <div className="Dictionary">
            <section>
            <form onSubmit={search}>
                <input type="search" onChange={handleKeywordChange} />
            </form>
            <Results results={results} />
            <Photos photos={photos} />
            </section>
        </div>
        
    );
}